
import _ from 'lodash';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {useStore} from '@nanostores/react';


import { $statementStatus, resetStatementSalt } from '../../stores/StatusStore.jsx';
import NonRegisteredStepWidget from './NonRegisteredStepWidget.jsx';
import StatementStatusWidget from './StatementStatusWidget.jsx';
import QrWidget from '../QrWidget.jsx';
import { $productConfig } from '../../stores/Config.jsx';


const Layout = ({children}) => (
    <div className="trit-container trit-container-print">
        <header>
            <img src="images/logo.png" alt="logo" />
            <h1>Приём заявления в электронном виде</h1>
            <br />
        </header>

        <div className="col-md-12">          
            {children}
        </div>
    </div>
);


export default  () => {
    const
        params = useParams(),
        navigate = useNavigate(),        
        config = useStore($productConfig),
        $status = $statementStatus(params.statementId),
        status = useStore($status),
        //
        isLoaded = status?.isLoaded,
        lastError = status?.lastError,
        //
        uid = status?.id,
        data = status?.data,
        //
        onRetryClicked = () => {
            document.location.reload();
        },
        onCodeResaltClicked = () => {
            resetStatementSalt($status)
            .then((data) => {
                navigate(`/status/${data.statement_id}`)
            })
        };

    if(_.isNil(isLoaded)) {
        return (
            <Layout>
                <div className="spinner-border" />
                <div>Загрузка данных</div>
            </Layout>
        );
    }
    
    if(isLoaded === false) {
        return (
            <Layout>
                <div className="card border-danger">
                    <div className="card-header text-bg-danger">Ошибка загрузки</div>
                    <div className="card-body">
                        <div>Невозможно загрузить информацию о заявлении.</div>
                        <div><strong>Ошибка:</strong> {lastError.message}</div>
                    </div>
                    <div className="card-footer">
                        <button className="btn btn-warning" onClick={onRetryClicked}>
                            <i className="bi bi-arrow-circle" />
                            Повторить попытку
                        </button>
                    </div>
                </div>
            </Layout>
        );
    }

    return (
        <div className="trit-container trit-container-print">
            <header>
                <img src="images/logo.png" alt="logo" />
                <h1>Приём заявления в электронном виде</h1>
                <br />
            </header>

            <div className="col-md-12">          
                {!data?.is_registered
                    ?<NonRegisteredStepWidget />
                    :null
                }

                <div className="d-md-flex align-items-center mb-4 text-center">
                    <QrWidget imageUrl={config.status_qr_url(uid)} />
                    <div>
                        <div className="text-md-start text-muted">
                            <i className="bi bi-arrow-left d-none d-md-inline" />&nbsp;
                            По этому QR-коду вы всегда сможете <strong>посмотреть состояние своего заявления</strong> а также упростить его поиск при личном посещении приёмной комиссии.
                            Сфотографируйте его и сохраните в удобном месте.
                        </div>
                        <div className="text-md-start text-muted">
                            Вы всегда можете сбросить и изменить этот код. При этом все предыдущие коды перестанут действовать.
                            <div className="">
                                <button className="btn btn-outline-danger btn-sm" onClick={onCodeResaltClicked}>Сбросить код</button>
                            </div>
                        </div>

                    </div>
                </div>

    
                {data
                    ?<StatementStatusWidget uid={uid} data={data} />
                    :null
                }
            </div>
        </div>
    );
}

